import { OutputAttribute, TogglableInputAttribute } from "src/clients/flow-api";
import { AgentNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractInputMappings } from "src/flowGraph/canvasSearch/nodesExtractors/utils";

const extractFilesField = (
  files: TogglableInputAttribute | undefined,
): SearchableField[] => {
  if (!files) {
    return [];
  }
  return [
    {
      id: files.id,
      value: files.expression,
    },
  ];
};

const extractResponseField = (
  response: OutputAttribute | undefined,
): SearchableField[] => {
  if (!response) {
    return [];
  }
  return [
    {
      id: response.id,
      value: `data.${response.mapped_to}`,
    },
  ];
};

export const extractAgentNodeFields = (
  data: AgentNodeData,
  nodeId: string,
): SearchableField[] => {
  return [
    ...extractInputMappings(data.input_mappings),
    ...extractResponseField(data.response.default),
    ...extractFilesField(data.files),
    {
      id: `${nodeId}:prompt`,
      value: data.prompt,
    },
  ];
};
